export const PerfectStoreListColConfig = [
  {
    name_of_db_column: 'targetName',
    label_of_column: 'Target Name',
    order_of_column: 1,
    filterable: true
  },
  {
    name_of_db_column: 'targetType',
    label_of_column: 'Target Type',
    order_of_column: 2,
    filterable: true
  },
  {
    name_of_db_column: 'storeCount',
    label_of_column: '# Stores',
    order_of_column: 3,
    filterable: true
  },
  {
    name_of_db_column: 'percentAchievedTarget',
    label_of_column: '% Achieved Target',
    order_of_column: 4,
    filterable: false,
    hideSortIcon: true
  },
  {
    name_of_db_column: 'pointsAwarded',
    label_of_column: 'Points Awarded',
    order_of_column: 5,
    filterable: true
  },
  {
    name_of_db_column: 'status',
    label_of_column: 'Status',
    order_of_column: 6,
    filterable: true
  },
  {
    name_of_db_column: 'startDate',
    label_of_column: 'Start Date',
    order_of_column: 7,
    filterVariant: 'dateRange',
    initialSize: 250,
    columnFilterPlaceholder: 'Start Date',
    filterable: true
  },
  {
    name_of_db_column: 'endDate',
    label_of_column: 'End Date',
    order_of_column: 8,
    filterVariant: 'dateRange',
    initialSize: 250,
    columnFilterPlaceholder: 'End Date',
    filterable: true
  },
  {
    name_of_db_column: 'reportUrl',
    label_of_column: 'Report',
    order_of_column: 9,
    filterable: false,
    hideSortIcon: true
  },
  {
    name_of_db_column: 'updatedAt',
    label_of_column: 'Last Updated',
    order_of_column: 10,
    filterVariant: 'dateRange',
    initialSize: 250,
    columnFilterPlaceholder: 'Last Updated',
    filterable: true
  },
  {
    name_of_db_column: 'updatedBy',
    label_of_column: 'Updated By',
    order_of_column: 11,
    filterable: true
  }
];
